import React from "react";
import { Sun, BatteryCharging, Plug, Compass, ArrowUpRight } from "lucide-react";

const services = [
  {
    id: "photovoltaik",
    icon: Sun,
    title: "Photovoltaik",
    desc: "Hocheffiziente Solaranlagen, präzise auf Ihr Dach geplant. Solarmodule, intelligente Wechselrichter, optimaler Eigenverbrauch.",
    image:
      "https://images.unsplash.com/photo-1509391366360-2e959784a276?auto=format&fit=crop&w=1600&q=80",
    points: ["Dachanalyse & 3D-Planung", "Installation", "Monitoring per App"],
  },
  {
    id: "batteriespeicher",
    icon: BatteryCharging,
    title: "Batteriespeicher",
    desc: "Mehr Unabhängigkeit. Sonnenstrom speichern und dann nutzen, wenn Sie ihn brauchen – auch nachts.",
    image:
      "https://images.unsplash.com/photo-1605980413988-9ff24c537935?auto=format&fit=crop&w=1600&q=80",
    points: ["Bis 80 % Eigenverbrauch", "Notstrom-Funktion", "Modular erweiterbar"],
  },
  {
    id: "wallbox",
    icon: Plug,
    title: "Wallbox",
    desc: "Laden Sie Ihr Elektroauto mit eigenem Sonnenstrom. Intelligente Steuerung, sicher und förderfähig.",
    image:
      "https://images.unsplash.com/photo-1593941707882-a5bba14938c7?auto=format&fit=crop&w=1600&q=80",
    points: ["PV-Überschussladen", "Bis 22 kW Leistung", "RFID & App-Steuerung"],
  },
  {
    id: "beratung",
    icon: Compass,
    title: "Beratung",
    desc: "Wirtschaftlichkeit, Förderungen, technische Auslegung. Beratung ohne Verkaufsdruck.",
    image:
      "https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1600&q=80",
    points: ["Wirtschaftlichkeits-Analyse", "Förderanträge", "Unabhängig & transparent"],
  },
];

export default function Services() {
  return (
    <section
      id="leistungen"
      data-testid="services-section"
      className="section bg-[var(--sol-bg)] relative"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <p className="eyebrow">Leistungen</p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-extralight tracking-tight mt-6 text-white leading-[1.05]">
            Vier Disziplinen.
            <br />
            <span className="bronze-metallic">Ein Standard.</span>
          </h2>
          <p className="font-body text-base md:text-lg text-white/55 mt-8 leading-relaxed max-w-2xl">
            Von der ersten Skizze bis zur Inbetriebnahme – wir liefern jede Komponente
            Ihres Energiesystems in derselben kompromisslosen Qualität.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8 mt-16">
          {services.map((s) => {
            const Icon = s.icon;
            return (
              <article
                key={s.id}
                data-testid={`service-card-${s.id}`}
                className="group relative overflow-hidden rounded-3xl bg-[var(--sol-surface)] border border-white/5 hover:border-[var(--sol-bronze)]/40 transition-all duration-500"
              >
                <div className="relative h-56 md:h-64 overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105 transition-all duration-1000"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[var(--sol-surface)] via-[var(--sol-surface)]/40 to-transparent" />
                  <div className="absolute top-6 left-6 w-12 h-12 rounded-full bg-[var(--sol-bronze)]/15 backdrop-blur-md border border-[var(--sol-bronze)]/30 flex items-center justify-center">
                    <Icon size={20} strokeWidth={1.5} className="text-[var(--sol-bronze-light)]" />
                  </div>
                </div>

                <div className="p-8 md:p-10 -mt-2">
                  <h3 className="font-display text-2xl md:text-3xl text-white font-light tracking-tight">
                    {s.title}
                  </h3>
                  <p className="font-body text-white/55 mt-4 leading-relaxed text-sm md:text-base">
                    {s.desc}
                  </p>
                  <ul className="mt-6 space-y-2.5">
                    {s.points.map((p) => (
                      <li
                        key={p}
                        className="flex items-center gap-3 text-white/70 text-sm font-body"
                      >
                        <span className="h-px w-6 bg-[var(--sol-bronze)]/70" />
                        {p}
                      </li>
                    ))}
                  </ul>

                  <div className="mt-8 pt-6 border-t border-white/5 flex items-center justify-between">
                    <span className="text-[11px] tracking-[0.22em] uppercase text-white/40 font-body">
                      Mehr erfahren
                    </span>
                    <ArrowUpRight
                      size={18}
                      className="text-[var(--sol-bronze)] group-hover:rotate-45 transition-transform duration-500"
                    />
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
